import styled from 'styled-components';
import {
  SunYellow,
  NiceBlue,
  WhiteFour,
  WarmGrey,
  DarkishBlue
} from '../../styles/Colours';

export const Button = styled.button`
  display: inline-block;
  position: relative;
  border-radius: 3px;
  width: ${props => (props.width ? props.width : '100%')};
  border: none;
  height: 60px;
  box-shadow: none;
  cursor: pointer;
  padding: 0 35px;
  outline: none;
  background: ${props =>
    props.category
      ? props.category === 'primary'
        ? SunYellow
        : props.category === 'secondary'
          ? NiceBlue
          : 'transparent'
      : 'transparent'};
  border: 1px solid
    ${props =>
      props.category
        ? props.category === 'primary'
          ? SunYellow
          : props.category === 'secondary'
            ? NiceBlue
            : 'transparent'
        : 'transparent'};
  color: ${props =>
    props.category
      ? props.category === 'primary'
        ? NiceBlue
        : props.category === 'secondary'
          ? WhiteFour
          : WarmGrey
      : 'transparent'};

  &:disabled {
    opacity: 0.5;
  }
`;

export const Label = styled.div`
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  float: left;
  margin-top: 11px;
`;

export const I = styled.div`
  display: inline-block;
  float: right;
  font-size: 30px;
`;

export const Loading = styled.div`
  position: absolute;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props =>
    props.category
      ? props.category === 'primary'
        ? SunYellow
        : props.category === 'secondary'
          ? NiceBlue
          : 'transparent'
      : 'transparent'};
  border: 1px solid
    ${props =>
      props.category
        ? props.category === 'primary'
          ? SunYellow
          : props.category === 'secondary'
            ? NiceBlue
            : 'transparent'
        : 'transparent'};
  color: ${props =>
    props.category
      ? props.category === 'primary'
        ? NiceBlue
        : props.category === 'secondary'
          ? WhiteFour
          : WarmGrey
      : 'transparent'};
`;

export const CancelButton = styled.button`
  display: inline-block;
  position: relative;
  border-radius: 3px;
  width: ${props => (props.width ? props.width : '100%')};
  border: none;
  height: 60px;
  box-shadow: none;
  cursor: pointer;
  padding: 0 35px;
  outline: none;
  background: transparent;
  border: 1px solid ${WarmGrey};
  color: ${WarmGrey};

  ${I} {
    float: left;
  }

  ${Label} {
    float: right;
  }
`;

export const Basic = styled.button`
  display: inline-block;
  position: relative;
  border-radius: 3px;
  padding: 20px 40px;
  border: none;
  box-shadow: none;
  cursor: pointer;
  outline: none;
  background: ${props => (props.secondary ? DarkishBlue : WhiteFour)};
  border: 1px solid ${props => (props.secondary ? WhiteFour : DarkishBlue)};
  color: ${props => (props.secondary ? WhiteFour : DarkishBlue)};
  font-size: 16px;
  font-weight: 500;
  text-align: center;

  ${Loading} {
    background: ${props => (props.secondary ? DarkishBlue : WhiteFour)};
    border: 1px solid ${props => (props.secondary ? WhiteFour : DarkishBlue)};
    color: ${props => (props.secondary ? WhiteFour : DarkishBlue)};
  }
`;

export const FormBtn = styled.button`
  margin-top: 20px;
  float: right;
  background: ${NiceBlue};
  border: none;
  box-shadow: none;
  outline: none;
  padding: 20px 50px;
  color: ${WhiteFour};
  cursor: pointer;
  border-radius: 3px;
  position: relative;

  &:active,
  &:hover,
  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
    outline-width: 0;
    outline-color: transparent;
  }

  ${Loading} {
    background: ${NiceBlue};
    border: none;
    color: ${WhiteFour};
  }
`;


export const BackButtonStyle = styled.button`
  display: inline-block;
  position: relative;
  border: none;
  box-shadow: none;
  cursor: pointer;
  outline: none;
  background: transparent;
  color: ${NiceBlue};
  font-size: 16px;
`;

export const BackLabel = styled.div`
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
`;

export const RightButtonStyle = styled(BackButtonStyle)`
  float: right;
`;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonStyles.js